/* Pure Desi · My Diwali list (2 Oct 2026). Spec: ~/Developer/pure-desi-diwali-list/docs/2026-10-02-diwali-list-design.md
   Needs window.PDListCore (pd-list-core.js) and #pd-list-config (snippets/pd-list.liquid).
   Adds a "My Diwali list" button to the cart drawer and a card to the cart page, opens the planner as a sheet (also on its own after a
   second page view, see maybeAutoOpen), and mounts it on /pages/my-diwali-list. New shoppers answer two gift-planner questions first. */
(function () {
  "use strict";
  if (window.__pdList) return;
  window.__pdList = true;
  var C = window.PDListCore, cfgEl = document.getElementById("pd-list-config");
  if (!C || !cfgEl) return;
  var CFG = { api: cfgEl.getAttribute("data-api"), klCompany: cfgEl.getAttribute("data-kl-company"), klList: cfgEl.getAttribute("data-kl-list") };
  var SITE = "https://www.puredesi.shop", PAGE_PATH = "/pages/my-diwali-list";
  var LS_LIST = "pd_list_v1", LS_ME = "pd_list_me_v1", EMAIL_QUIET_MS = 60000, API_TIMEOUT_MS = 10000;
  var SS_PV = "pd_list_pv", SS_SHOWN = "pd_list_shown", LS_DISMISSED = "pd_list_dismissed_at", POPUP_DELAY_MS = 5000, STEP_TAP_GUARD_MS = 300;
  var HOME_LABELS = { "1": "1 home", "2-4": "2\u20134 homes", "5-9": "5\u20139 homes", "10+": "10 or more" };
  var TASTE_LABELS = { kaju: "Kaju", ladoo: "Ladoo", burfi: "Burfi", syrup: "Syrup sweets", mix: "A mix of everything" };
  var SOURCES = { "pop-up": "My Diwali list (pop-up)", drawer: "My Diwali list (drawer)", "cart-page": "My Diwali list (cart page)",
    card: "My Diwali list (add from a card)", product: "My Diwali list (add from a product page)", bar: "My Diwali list (bottom bar)", plan: "My Diwali list (plan button)" };

  function load(k) { try { return JSON.parse(localStorage.getItem(k) || "null"); } catch (e) { return null; } }
  function keep(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} if (k === LS_LIST) emitChange(v); }
  // Tells the page the list changed (the bottom bar's List count listens). Every write of the list goes through keep().
  function emitChange(l) { try { document.dispatchEvent(new CustomEvent("pd-list-change", { detail: { count: C.boxCount(l && l.lines) } })); } catch (e) {} }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function own(o, k) { return typeof k === "string" && Object.prototype.hasOwnProperty.call(o, k); }
  // A list is { id, lines, notes, emailed, updated_at, pending }. pending = edited here and not yet saved to the server.
  function freshList() { var l = C.emptyList(); l.pending = false; return l; }
  function loadList() { var l = load(LS_LIST); return l && typeof l === "object" && Array.isArray(l.lines) ? l : freshList(); }
  function fromServer(res, emailed) {
    return { id: res.id, notes: res.notes || "", emailed: !!emailed, updated_at: res.updated_at, pending: false,
      lines: (res.lines && res.lines.length ? res.lines : C.emptyList().lines).map(function (l) { return { name: l.name || "", variant_id: l.variant_id ? String(l.variant_id) : "", qty: l.qty || 1 }; }) };
  }

  var S = { me: load(LS_ME), list: loadList(), catalog: null, host: null, mode: null, view: "", busy: false, suggested: "",
    step: 1, plan: { homes: "", taste: "" }, draft: { first_name: "", email: "" }, seed: null, entry: null,
    addFirst: false, focusLine: null }; // addFirst: a new shopper saved a box from a card or product page, so the gate is just name and email
  var sheet = null, opener = null, pageHost = null, saveTimer = null, retryTimer = null, retryDelay = 5000, saving = false, saveAgain = false, stopped = false, editSeq = 0, startSeq = 0, swapResolve = null, emailTimer = null, emailDue = false, saveAgainKeep = false, catalogP = null, stepAt = 0, autoArmed = false;

  // ---------- network ----------
  function loadCatalog() {
    return fetch("/collections/diwali/products.json?limit=250", { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("catalog " + r.status); return r.json(); })
      .then(function (j) { S.catalog = C.parseCatalog(j); return S.catalog; });
  }
  function getCatalog() {
    if (S.catalog) return Promise.resolve(S.catalog);
    if (!catalogP) catalogP = loadCatalog().catch(function (e) { catalogP = null; throw e; });
    return catalogP;
  }
  // Always asks Shopify again (sold-out status must be current when we add). The old copy stays in place until the new one arrives, and is used if the refetch fails.
  function refreshCatalog() { return loadCatalog().catch(function (e) { if (S.catalog) return S.catalog; throw e; }); }
  // opts.keepalive lets a small request finish after the page unloads. Every call times out after 10 s where AbortController exists.
  function api(method, path, body, opts) {
    var init = { method: method, headers: body ? { "Content-Type": "application/json" } : {}, body: body ? JSON.stringify(body) : undefined };
    if (opts && opts.keepalive) init.keepalive = true;
    var ctl = typeof AbortController !== "undefined" ? new AbortController() : null, timer = null, timedOut = false;
    if (ctl) { init.signal = ctl.signal; timer = setTimeout(function () { timedOut = true; ctl.abort(); }, API_TIMEOUT_MS); }
    return fetch(CFG.api + path, init)
      .then(function (r) {
        if (r.status === 204) return null;
        return r.json().catch(function () { if (timedOut) throw new Error("timeout"); return {}; }).then(function (j) {
          if (!r.ok) { var e = new Error((j && j.error) || String(r.status)); e.status = r.status; throw e; }
          return j;
        });
      })
      .then(function (v) { clearTimeout(timer); return v; }, function (e) { clearTimeout(timer); throw e; });
  }
  function shop(method, path, body) {
    return fetch(path, { method: method, credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: body ? JSON.stringify(body) : undefined })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || (j && j.status >= 400)) { var e = new Error((j && (j.description || j.message)) || String(r.status)); e.status = r.status; throw e; }
          return j;
        });
      });
  }

  // ---------- Klaviyo (public site key only; no secrets) ----------
  // opts.keepalive lets the request finish after the page is left (the "email on leave" path).
  function kl(path, body, opts) {
    var init = {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", Accept: "application/vnd.api+json", revision: "2024-10-15" },
      body: JSON.stringify(body)
    };
    if (opts && opts.keepalive) init.keepalive = true;
    return fetch("https://a.klaviyo.com/client/" + path + "/?company_id=" + encodeURIComponent(CFG.klCompany), init)
      .then(function (r) { if (!r.ok) throw new Error("klaviyo " + r.status); });
  }
  function retryOnce(fn) { return fn().catch(function () { return wait(3000).then(fn); }); }
  // source says how the planner was opened (pop-up, drawer, cart page); the list page and anything else keep the plain name.
  function entrySource() { return (S.mode === "sheet" && own(SOURCES, S.entry)) ? SOURCES[S.entry] : "My Diwali list"; }
  function klSubscribe(me, source) {
    return retryOnce(function () {
      return kl("subscriptions", { data: { type: "subscription", attributes: {
        custom_source: source || "My Diwali list",
        // No "subscriptions" key: revision 2024-10-15 rejects it (400) and the list's single opt-in records the consent.
        profile: { data: { type: "profile", attributes: { email: me.email } } }
      }, relationships: { list: { data: { type: "list", id: CFG.klList } } } } });
    });
  }
  // me is the shopper at call time, so the retry still goes to the same person if they forget this list meanwhile.
  // uniqueId is fixed by the caller before the first try: Klaviyo keeps only the first event with a given unique_id per profile, so a retry or a second tab cannot send the email twice.
  function klEvent(props, me, uniqueId, opts) {
    return retryOnce(function () {
      return kl("events", { data: { type: "event", attributes: {
        properties: props,
        unique_id: uniqueId,
        metric: { data: { type: "metric", attributes: { name: "Diwali List Email" } } },
        profile: { data: { type: "profile", attributes: { email: me.email, first_name: me.first_name } } }
      } } }, opts);
    });
  }
  // plan = the two opening answers; sent under the same property names the old gift planner pop-up used.
  function klIdentify(me, plan) {
    try {
      if (!window.klaviyo || !window.klaviyo.identify) return;
      var p = { email: me.email, first_name: me.first_name };
      if (plan && plan.homes) p.pd_plan_homes = plan.homes;
      if (plan && plan.taste) p.pd_plan_taste = plan.taste;
      window.klaviyo.identify(p);
    } catch (e) {}
  }

  // ---------- saving ----------
  function setStatus(t, isError) {
    var el = S.host && S.host.querySelector(".pd-list__status");
    if (!el) return;
    el.textContent = t;
    el.className = "pd-list__status" + (isError ? " pd-list__status--err" : "");
  }
  function touch() {
    editSeq++; stopped = false;
    S.list.updated_at = Date.now(); S.list.pending = true; keep(LS_LIST, S.list);
    setStatus("Saving…"); clearTimeout(saveTimer); saveTimer = setTimeout(flush, 800);
    renderSummary(); scheduleEmail();
  }
  function flushIfPending() { if (S.list.pending && !stopped) flush(); }
  function resetSync() { clearTimeout(saveTimer); clearTimeout(retryTimer); cancelEmail(); saveAgain = false; saveAgainKeep = false; retryDelay = 5000; stopped = false; }
  // opts.keepalive: the page is being left, so let the request outlive it. (setTimeout may hand flush a number, which has no .keepalive.)
  function flush(opts) {
    var keepalive = !!(opts && opts.keepalive);
    if (saving) { saveAgain = true; if (keepalive) saveAgainKeep = true; return; }
    saving = true; clearTimeout(retryTimer); clearTimeout(saveTimer);
    var target = S.list, seq = editSeq, had = target.id, body = C.toPayload(target), ko = keepalive ? { keepalive: true } : undefined;
    var p = had ? api("PUT", "/api/lists/" + had, body, ko) : api("POST", "/api/lists", body, ko);
    p.then(function (res) {
      if (!had && !(res && C.isValidId(res.id))) throw new Error("unreadable reply"); // no status, so it counts as a network failure and retries
      if (S.list !== target) { if (S.list.pending) saveAgain = true; return; } // the shopper moved to another list while this was in flight
      if (!had) target.id = res.id;
      if (editSeq === seq) { target.pending = false; retryDelay = 5000; setStatus("Saved"); } else saveAgain = true; // edited again meanwhile: still pending
      keep(LS_LIST, target);
    }).catch(function (e) {
      if (S.list !== target) { if (S.list.pending) saveAgain = true; return; }
      var st = e && e.status;
      if (st === 404 && had) { target.id = null; target.emailed = false; keep(LS_LIST, target); saveAgain = true; return; }
      if (st >= 400 && st < 500 && st !== 429) { // 400, 403, 410 and the like: sending it again cannot help
        stopped = true; setStatus("We couldn't save this list. Please refresh the page.", true); return;
      }
      setStatus("Not saved yet. We'll keep trying.", true); // network error, timeout, 429 or 5xx: back off and retry
      retryTimer = setTimeout(flush, retryDelay); retryDelay = Math.min(retryDelay * 2, 60000);
    }).then(function () { saving = false; if (saveAgain) { var ka = saveAgainKeep; saveAgain = false; saveAgainKeep = false; flush(ka ? { keepalive: true } : undefined); } });
  }

  // ---------- email ----------
  function cancelEmail() { clearTimeout(emailTimer); emailDue = false; }
  function scheduleEmail(delay) {
    if (!S.me || !S.me.email || S.list.emailed) return;
    clearTimeout(emailTimer); emailDue = true;
    emailTimer = setTimeout(function () { emailDue = false; sendEmail("created").catch(function () {}); }, delay || EMAIL_QUIET_MS);
  }
  // opts.keepalive: sent as the shopper leaves the page.
  function sendEmail(kind, opts) {
    if (!S.me || !S.me.email) return Promise.reject(new Error("no email"));
    if (!S.list.id) { if (kind === "created") scheduleEmail(); return Promise.reject(new Error("not saved yet")); }
    var s = C.summarize(S.list.lines, S.catalog || []);
    if (kind === "created" && (S.list.emailed || !s.boxes)) return Promise.resolve(false);
    var listId = S.list.id, me = S.me, uid = kind === "created" ? listId + ":created" : listId + ":resend:" + Date.now();
    return klEvent(C.eventProps(S.list, S.catalog || [], kind, SITE + PAGE_PATH + "?l=" + listId), me, uid, opts).then(function () {
      if (S.list.id === listId) { S.list.emailed = true; keep(LS_LIST, S.list); cancelEmail(); }
      return true;
    });
  }
  // The shopper is leaving (tab hidden or page closed): save what is pending, and send the "created" email now rather than lose it to the 60 s wait.
  function onLeave() {
    if (S.list.pending && !stopped) flush({ keepalive: true });
    if (emailDue && S.me && S.me.email && S.list.id && !S.list.emailed && C.summarize(S.list.lines, S.catalog || []).boxes) {
      cancelEmail();
      sendEmail("created", { keepalive: true }).catch(function () {}); // not marked as emailed until it succeeds; the unique_id makes a later resend harmless
    }
  }
  function resend(b) {
    b.disabled = true;
    sendEmail("resend").then(function () { b.textContent = "Sent. It should arrive in a minute."; })
      .catch(function () { b.disabled = false; b.textContent = "Not sent yet. Try again in a moment."; });
  }

  // ---------- rendering ----------
  function noteHTML(title, body) {
    return '<div class="pd-list__top"><h2 class="pd-list__title">' + esc(title) + '</h2><p class="pd-list__lede">' + esc(body) + "</p></div>";
  }
  // The details gate is three steps: how many homes, which sweets, then name and email. Steps 1 and 2 are one tap each.
  function gateStep() {
    if (S.addFirst) return 3;
    var st = S.step;
    if (st > 1 && !S.plan.homes) st = 1;
    if (st > 2 && !S.plan.taste) st = 2;
    return st;
  }
  function gateTop(step, title, lede) {
    return '<div class="pd-list__top"><p class="pd-list__eyebrow">Diwali 2026' + (step ? ' · Step ' + step + ' of 3' : '') + '</p><h2 class="pd-list__title" tabindex="-1">' + esc(title) + "</h2>" +
      (lede ? '<p class="pd-list__lede">' + esc(lede) + "</p>" : "") + "</div>";
  }
  function choicesHTML(act, values, labels, chosen) {
    return '<div class="pd-list__grid">' + values.map(function (v) {
      return '<button type="button" class="pd-list__choice" data-act="' + act + '" data-v="' + esc(v) + '" aria-pressed="' + (v === chosen ? "true" : "false") + '">' + esc(labels[v]) + "</button>";
    }).join("") + "</div>";
  }
  function gateHTML() {
    var st = gateStep();
    if (st === 1) {
      return gateTop(1, "How many homes are you giving to this Diwali?") +
        '<div class="pd-list__choices">' + choicesHTML("homes", C.HOMES, HOME_LABELS, S.plan.homes) + "</div>";
    }
    if (st === 2) {
      return gateTop(2, "Which sweets do they love?") +
        '<div class="pd-list__choices">' + choicesHTML("taste", C.TASTES, TASTE_LABELS, S.plan.taste) +
        '<button type="button" class="pd-list__back" data-act="back">Back</button></div>';
    }
    var add = S.addFirst;
    return (add ? gateTop(0, "Save it to your Diwali list", "Then add a name for each home, change anything you like, and add it all to your bag in one tap. We'll email you a private link so your list is there on any device.")
      : gateTop(3, "Prepare your Diwali list", "We'll set up a list with a box for each home. Change anything you like, then add it all to your bag in one tap. We'll email you a link so your list is there on any device.")) +
      '<form class="pd-list__gate" novalidate>' +
      '<label>First name<input name="first_name" autocomplete="given-name" maxlength="40" required value="' + esc(S.draft.first_name) + '"></label>' +
      '<label>Email<input name="email" type="email" autocomplete="email" inputmode="email" required value="' + esc(S.draft.email) + '"></label>' +
      '<p class="pd-list__suggest" hidden>Did you mean <button type="button" data-act="use-suggest"></button>?</p>' +
      '<p class="pd-list__err" role="alert" hidden></p>' +
      '<p class="pd-list__consent">We\'ll email you your list and Diwali updates. Unsubscribe any time.</p>' +
      '<button class="pd-list__cta" type="submit">' + (add ? "Save my list" : "Open my list") + '</button>' +
      (add ? "" : '<button type="button" class="pd-list__back" data-act="back">Back</button>') + '</form>';
  }
  // After a step changes, put focus on the new heading so keyboard and screen-reader users land at the top of it (no keyboard pops up on a phone).
  function focusTitle() { var t = S.host && S.host.querySelector(".pd-list__title"); if (t && t.focus) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } } }
  function rowHTML(l, i, cat) {
    var idx = C.indexCatalog(cat), c = l.variant_id ? idx[String(l.variant_id)] : null;
    var opts = '<option value="">Choose a box</option>' + cat.map(function (b) {
      return '<option value="' + b.variant_id + '"' + (b.variant_id === String(l.variant_id) ? " selected" : "") + (b.available ? "" : " disabled") + ">" +
        esc(b.title) + " · " + C.money(b.price) + (b.available ? "" : " (sold out)") + "</option>";
    }).join("");
    if (l.variant_id && !c) opts += '<option value="' + esc(l.variant_id) + '" selected disabled>No longer available</option>';
    var warn = l.variant_id && (!c || !c.available) ? '<p class="pd-list__warn">Sold out, choose another box</p>' : "";
    return '<div class="pd-list__row" data-i="' + i + '">' +
      '<input class="pd-list__name" data-f="name" value="' + esc(l.name) + '" maxlength="40" placeholder="Name, e.g. Mum &amp; Dad" aria-label="Who this box is for">' +
      '<select class="pd-list__box" data-f="variant_id" aria-label="Box">' + opts + "</select>" +
      '<div class="pd-list__qty"><button type="button" data-act="dec" aria-label="One fewer">−</button><span>' + esc(l.qty) + '</span><button type="button" data-act="inc" aria-label="One more">+</button></div>' +
      '<button type="button" class="pd-list__rm" data-act="rm" aria-label="Remove this line">×</button>' + warn + "</div>";
  }
  function listHTML() {
    var cat = S.catalog || [], s = C.summarize(S.list.lines, cat);
    var hi = S.me && S.me.first_name ? "Hi " + esc(S.me.first_name) : "Welcome back";
    return '<div class="pd-list__top"><p class="pd-list__eyebrow">' + hi + '</p><h2 class="pd-list__title">My Diwali list</h2><p class="pd-list__meta">' + esc(C.metaLine(s)) + "</p></div>" +
      '<div class="pd-list__head" aria-hidden="true"><span>For</span><span>Box</span><span>Qty</span></div>' +
      '<div class="pd-list__rows">' + S.list.lines.map(function (l, i) { return rowHTML(l, i, cat); }).join("") + "</div>" +
      '<button type="button" class="pd-list__addline" data-act="add"' + (S.list.lines.length >= C.LIMITS.lines ? " hidden" : "") + ">+ Add a name</button>" +
      '<label class="pd-list__noteslabel">Notes <span>Private, not added to your order</span><textarea class="pd-list__notes" data-f="notes" maxlength="1000" rows="3" placeholder="Who still needs a box? Which store for pickup?">' + esc(S.list.notes) + "</textarea></label>" +
      '<p class="pd-list__status" aria-live="polite"></p>' +
      '<div class="pd-list__msg" role="status" tabindex="-1" hidden></div>' +
      '<div class="pd-list__foot"><div class="pd-list__total">Total<b>' + C.money(s.cents) + '</b></div><button type="button" class="pd-list__cta" data-act="addall">Add all to bag</button></div>' +
      '<div class="pd-list__links">' + (S.me && S.me.email ? '<button type="button" data-act="resend">Email me my list again</button>' : "") +
      '<button type="button" data-act="new">Start a new list</button><button type="button" data-act="forget">Forget this list on this phone</button></div>';
  }
  function render(view) {
    settleSwap(false); // a redraw removes the swap prompt, so answer it "no" and let addAll finish
    S.view = view;
    if (!S.host) return;
    if (view === "gate") { S.host.innerHTML = gateHTML(); stepAt = Date.now(); }
    else if (view === "loading") S.host.innerHTML = '<p class="pd-list__loading">Opening your list…</p>';
    else if (view === "closed") S.host.innerHTML = noteHTML("Diwali pre-orders have closed", "Thank you for planning with us.");
    else if (view === "notfound") S.host.innerHTML = noteHTML("We couldn't find that list", "It may have been cleared.") + '<button type="button" class="pd-list__cta pd-list__solo" data-act="new">Start a new list</button>';
    else if (view === "error") S.host.innerHTML = noteHTML("Your list didn't load", "Please check your connection and try again.") + '<button type="button" class="pd-list__cta pd-list__solo" data-act="retry">Try again</button>';
    else if (view === "list") S.host.innerHTML = listHTML();
  }
  function renderRows() {
    var r = S.host && S.host.querySelector(".pd-list__rows");
    if (!r) return;
    r.innerHTML = S.list.lines.map(function (l, i) { return rowHTML(l, i, S.catalog || []); }).join("");
    var a = S.host.querySelector('[data-act="add"]'); if (a) a.hidden = S.list.lines.length >= C.LIMITS.lines;
  }
  function renderSummary() {
    if (!S.host || S.view !== "list") return;
    var s = C.summarize(S.list.lines, S.catalog || []), m = S.host.querySelector(".pd-list__meta"), t = S.host.querySelector(".pd-list__total b");
    if (m) m.textContent = C.metaLine(s);
    if (t) t.textContent = C.money(s.cents);
  }
  function showMsg(html) {
    var m = S.host && S.host.querySelector(".pd-list__msg"); if (!m) return;
    m.innerHTML = html; m.hidden = !html;
    if (html) { try { m.scrollIntoView({ block: "nearest" }); m.focus({ preventScroll: true }); } catch (e) {} }
  }
  // The catalogue can change while the shopper is away (a box sells out): redraw the total, and the rows unless they are typing in one.
  function refreshView() {
    if (S.view !== "list" || !S.host) return;
    renderSummary();
    var rows = S.host.querySelector(".pd-list__rows");
    if (rows && !(document.activeElement && rows.contains(document.activeElement))) renderRows();
  }

  // ---------- opening ----------
  function hasContent(l) { var p = C.toPayload(l); return !!(p.lines.length || p.notes); }
  // Adopt the server copy of the list so an edit made on another device shows up. Local edits that are not saved yet always win.
  function pullList() {
    var target = S.list;
    if (!S.me || !target.id || target.pending) return Promise.resolve();
    return api("GET", "/api/lists/" + target.id).then(function (res) {
      if (S.list !== target || target.pending) return; // edited or replaced while we waited
      if (!res || !C.isValidId(res.id)) return; // unreadable reply: keep the local copy
      S.list = fromServer(res, target.emailed); keep(LS_LIST, S.list);
    }, function (e) {
      if (e && e.status === 404 && S.list === target && !target.pending) { // the server no longer has it: keep the lines here and save them again
        target.id = null; target.emailed = false; if (hasContent(target)) target.pending = true; keep(LS_LIST, target);
      } // any other failure (offline, timeout, 5xx): keep the local copy
    });
  }
  function hasLines(l) { return (l.lines || []).some(function (x) { return String(x.name || "").trim() || x.variant_id; }); }
  // A new shopper's empty list becomes one box per home, from the two opening answers. A list that already has a name or a box is left alone.
  // Needs the catalogue (the caller has it). touch() saves it and starts the email timer, as for any edit. Returns true if the list was filled.
  function applyStarter(seed) {
    if (!seed || hasLines(S.list)) return false;
    var lines = C.starterLines(seed.homes, seed.taste, S.catalog || []);
    if (!lines.length) return false;
    S.list.lines = lines; touch();
    return true;
  }
  // A box added from a card or product page: its row is marked and its name field focused, so "who is this for?" is the next thing.
  function focusNewLine() {
    var i = S.focusLine; S.focusLine = null;
    if (i == null || !S.host) return;
    var row = S.host.querySelector('.pd-list__row[data-i="' + i + '"]'); if (!row) return;
    row.classList.add("pd-list__row--new");
    var n = row.querySelector(".pd-list__name"); if (n) { try { n.focus({ preventScroll: true }); row.scrollIntoView({ block: "nearest" }); } catch (e) { n.focus(); } }
  }
  function start(fresh) { // fresh = the list was just fetched, no need to pull it again
    var seq = ++startSeq;
    if (C.isClosed(Date.now())) return render("closed");
    if (!S.me) return render("gate");
    render("loading");
    getCatalog().then(function () { return fresh ? null : pullList(); }).then(function () {
      if (seq !== startSeq) return; // a newer start() has taken over
      var seed = S.seed; S.seed = null; // set when the shopper has just given their details; kept if the catalogue failed, so a retry still fills the list
      applyStarter(seed);
      render("list");
      focusNewLine();
      setStatus(S.list.pending ? "Saving…" : (S.list.id ? "Saved" : ""));
      if (S.list.pending) flush();
      else if (seed && !S.list.id) flush(); // a new shopper's list is created now so the email link exists
      if (S.list.id && !S.list.emailed && C.summarize(S.list.lines, S.catalog).boxes) scheduleEmail(5000);
    }).catch(function () { if (seq === startSeq) render("error"); });
  }

  // ---------- add all to bag ----------
  function settleSwap(yes) { var r = swapResolve; swapResolve = null; if (r) r(yes); } // answers the pending swap prompt (once); the buttons are handled in onClick
  function askSwap() {
    return new Promise(function (resolve) {
      swapResolve = resolve;
      showMsg("<strong>Your bag has everyday items.</strong> Diwali pre-orders check out on their own. Swap your bag for your Diwali list? The everyday items will be taken out." +
        '<span class="pd-list__swap"><button type="button" data-swap="yes">Use my Diwali list</button><button type="button" data-swap="no">Keep my bag</button></span>');
    });
  }
  function cartAdd(items, tries) {
    return shop("POST", "/cart/add.js", { items: items }).then(function () { return 0; }, function (e) {
      if (e.status === 429 && !tries) return wait(1500).then(function () { return cartAdd(items, 1); });
      var missed = 0; // add one at a time so one unavailable box doesn't block the rest
      return items.reduce(function (p, it) {
        return p.then(function () { return shop("POST", "/cart/add.js", { items: [it] }).catch(function () { missed += it.quantity; }); });
      }, Promise.resolve()).then(function () { return missed; });
    });
  }
  // Resolves to { chosen: lines with a box, planned: boxes we tried to add, added, missed: boxes the cart refused, skipped: lines whose box is sold out }
  function doAdd(cat, cartItems) {
    var plan = C.addPlan(S.list.lines, cat, cartItems);
    var res = { chosen: S.list.lines.filter(function (l) { return l.variant_id; }).length, planned: 0, added: 0, missed: 0, skipped: plan.skipped.length };
    if (!plan.items.length) return Promise.resolve(res);
    res.planned = plan.items.reduce(function (a, it) { return a + it.quantity; }, 0);
    return cartAdd(plan.items, 0).then(function (missed) {
      res.missed = missed; res.added = res.planned - missed;
      if (!res.added) return res; // nothing reached the bag, so nothing to mark
      return shop("POST", "/cart/update.js", { attributes: { _pd_list: "1" } }).catch(function () {}).then(function () {
        if (S.list.id) api("POST", "/api/lists/" + S.list.id + "/mark", { kind: "added" }, { keepalive: true }).catch(function () {});
        return res;
      });
    });
  }
  // Takes only the everyday lines out of the bag (one request); Diwali boxes and "any order" lines stay.
  // Rejects, with the bag untouched, when the theme helper that tells line types apart is missing.
  function swapEveryday(items) {
    var PM = window.PDDiwaliMode;
    if (!PM || typeof PM.lineType !== "function") return Promise.reject(new Error("no lineType"));
    var updates = {}, n = 0;
    (items || []).forEach(function (it) { if (it.key && PM.lineType(it) === "everyday") { updates[it.key] = 0; n++; } });
    return n ? shop("POST", "/cart/update.js", { updates: updates }) : Promise.resolve(null);
  }
  function soldOutNote(n) { return n === 1 ? "1 sold-out box wasn't added." : n + " sold-out boxes weren't added."; }
  // What to tell the shopper. needsEdit = they must change the list first (stay on it, no link to the bag); stay = keep the planner open.
  function addOutcome(r) {
    var notes = [], needsEdit = false, stay = false;
    if (!r.planned) {
      if (!r.chosen) { notes.push("Choose a box for at least one name first."); needsEdit = true; }
      else if (r.skipped >= r.chosen) { notes.push("The boxes on your list are sold out. Choose another box."); needsEdit = true; }
      else { notes.push("Everything on your list is already in your bag."); if (r.skipped) notes.push(soldOutNote(r.skipped)); }
    } else {
      if (!r.added) { notes.push("Your boxes couldn't be added. Please try again."); stay = true; }
      else if (r.missed) notes.push(r.missed === 1 ? "1 box couldn't be added. Please check your bag." : r.missed + " boxes couldn't be added. Please check your bag.");
      if (r.skipped) notes.push(soldOutNote(r.skipped));
    }
    return { notes: notes, stay: needsEdit || stay, bagLink: !needsEdit };
  }
  function addAll(btn) {
    if (S.busy) return;
    S.busy = true; btn.disabled = true; showMsg("");
    if (!S.list.emailed) { cancelEmail(); sendEmail("created").catch(function () {}); }
    Promise.all([refreshCatalog(), shop("GET", "/cart.js")]).then(function (x) {
      var cat = x[0], cart = x[1];
      refreshView();
      var mode = window.PDDiwaliMode && window.PDDiwaliMode.resolveMode ? window.PDDiwaliMode.resolveMode(cart.items) : (document.body.getAttribute("data-pd-mode") || "none");
      if (mode === "everyday" || mode === "mixed") {
        // Only offer to swap when the list has something to put in the bag.
        if (!C.addPlan(S.list.lines, cat, []).items.length) return doAdd(cat, []);
        return askSwap().then(function (yes) {
          if (!yes) return null;
          // The list may have changed while the prompt was up (an edit, a box selling out): check again before touching the bag.
          if (!C.addPlan(S.list.lines, cat, []).items.length) return doAdd(cat, []);
          return swapEveryday(cart.items).then(function () {
            return shop("GET", "/cart.js"); // what is left: Diwali boxes count toward the top-up, "any order" lines stay
          }).then(function (fresh) { return doAdd(cat, fresh.items); });
        });
      }
      return doAdd(cat, cart.items);
    }).then(function (r) {
      if (!r) return;
      var o = addOutcome(r);
      if (S.mode === "page") {
        if (!o.notes.length) { location.href = "/cart"; return; }
        showMsg(esc(o.notes.join(" ")) + (o.bagLink ? ' <a href="/cart">Go to your bag</a>' : ""));
        return;
      }
      if (o.stay) { // the sheet stays open so they can fix the list or try again
        if (r.planned) { if (window.refreshCart) window.refreshCart(); if (window.PDDiwaliMode && window.PDDiwaliMode.sync) window.PDDiwaliMode.sync(); }
        showMsg(esc(o.notes.join(" ")));
        return;
      }
      closeSheet();
      if (location.pathname === "/cart") { location.reload(); return; }
      if (window.refreshCart) window.refreshCart();
      if (window.PDDiwaliMode && window.PDDiwaliMode.sync) window.PDDiwaliMode.sync();
      var slotMsg = document.querySelector(".pd-list-slot__msg");
      if (slotMsg) { slotMsg.textContent = o.notes.join(" "); slotMsg.hidden = !o.notes.length; }
    }).catch(function () {
      showMsg("Something went wrong adding your boxes. Please try again.");
    }).then(function () { S.busy = false; btn.disabled = false; });
  }

  // ---------- events ----------
  function onClick(e) {
    var sw = e.target.closest("[data-swap]");
    if (sw) { showMsg(""); settleSwap(sw.getAttribute("data-swap") === "yes"); return; }
    var b = e.target.closest("[data-act]");
    if (!b) return;
    var act = b.getAttribute("data-act"), row = b.closest(".pd-list__row"), i = row ? +row.getAttribute("data-i") : -1;
    if (act === "close") return closeSheet();
    if (act === "use-suggest") {
      var inp = S.host.querySelector('input[name="email"]'); if (inp) inp.value = S.suggested;
      b.closest(".pd-list__suggest").hidden = true; return;
    }
    if (act === "homes" || act === "taste") {
      if (Date.now() - stepAt < STEP_TAP_GUARD_MS) return; // a double tap must not answer the next question too
      var v = b.getAttribute("data-v");
      if ((act === "homes" ? C.HOMES : C.TASTES).indexOf(v) < 0) return;
      S.plan[act] = v; S.step = act === "homes" ? 2 : 3; render("gate"); focusTitle();
      if (act === "homes") getCatalog().catch(function () {}); // load the boxes while they answer, so step 3 to the list is instant
      return;
    }
    if (act === "back") { S.step = Math.max(1, gateStep() - 1); render("gate"); focusTitle(); return; }
    if (act === "add") {
      if (S.list.lines.length >= C.LIMITS.lines) return;
      S.list.lines.push({ name: "", variant_id: "", qty: 1 }); renderRows(); touch();
      var names = S.host.querySelectorAll(".pd-list__name"); if (names.length) names[names.length - 1].focus();
      return;
    }
    if (act === "rm") {
      S.list.lines.splice(i, 1);
      if (!S.list.lines.length) S.list.lines.push({ name: "", variant_id: "", qty: 1 });
      renderRows(); touch(); return;
    }
    if (act === "inc" || act === "dec") {
      var l = S.list.lines[i];
      l.qty = Math.max(1, Math.min(C.LIMITS.qty, l.qty + (act === "inc" ? 1 : -1)));
      row.querySelector(".pd-list__qty span").textContent = l.qty; touch(); return;
    }
    if (act === "addall") return addAll(b);
    if (act === "resend") return resend(b);
    if (act === "new") {
      if (S.view === "list" && !window.confirm("Start a new list? This list will be cleared from this phone.")) return;
      resetSync(); S.list = freshList(); keep(LS_LIST, S.list);
      if (!(S.me && S.me.email)) { S.me = null; keep(LS_ME, null); resetGate(); } // a device that only opened a link has no details: go through the details step
      if (S.mode === "page" && location.search) history.replaceState(null, "", PAGE_PATH);
      return start();
    }
    if (act === "forget") {
      if (!window.confirm("Forget this list on this phone?")) return;
      resetSync(); keep(LS_LIST, null); keep(LS_ME, null); S.list = freshList(); S.me = null; resetGate();
      return start();
    }
    if (act === "retry") { // a list link that failed to load is fetched again; anything else (the catalogue, the sheet) just restarts
      var lid = linkId();
      if (S.mode === "page" && lid && lid !== S.list.id) return mountPage();
      return start();
    }
  }
  function onInput(e) {
    var t = e.target, f = t.getAttribute && t.getAttribute("data-f");
    if (!f && (t.name === "first_name" || t.name === "email") && t.form && t.form.classList.contains("pd-list__gate")) { S.draft[t.name] = t.value; return; } // so Back and forward do not lose it
    if (f === "notes") S.list.notes = t.value.slice(0, C.LIMITS.notes);
    else if (f === "name") S.list.lines[+t.closest(".pd-list__row").getAttribute("data-i")].name = t.value.slice(0, C.LIMITS.name);
    else return;
    touch();
  }
  function onChange(e) {
    var t = e.target;
    if (!t.getAttribute || t.getAttribute("data-f") !== "variant_id") return;
    var row = t.closest(".pd-list__row"), i = +row.getAttribute("data-i");
    S.list.lines[i].variant_id = t.value;
    row.outerHTML = rowHTML(S.list.lines[i], i, S.catalog || []);
    touch();
  }
  function onSubmit(e) {
    var form = e.target.closest(".pd-list__gate");
    if (!form) return;
    e.preventDefault();
    var name = form.elements.first_name.value.trim().slice(0, 40), email = form.elements.email.value.trim();
    var err = form.querySelector(".pd-list__err"), sug = form.querySelector(".pd-list__suggest");
    err.hidden = true;
    if (!name) { err.textContent = "Please add your first name."; err.hidden = false; return; }
    if (!C.validEmail(email)) { err.textContent = "Please check your email address."; err.hidden = false; return; }
    var better = C.suggestEmail(email);
    if (better && better !== S.suggested) { S.suggested = better; sug.querySelector("button").textContent = better; sug.hidden = false; return; }
    S.me = { first_name: name, email: email.toLowerCase() }; keep(LS_ME, S.me);
    var plan = { homes: S.plan.homes, taste: S.plan.taste };
    klIdentify(S.me, plan);
    klSubscribe(S.me, entrySource()).catch(function () {});
    S.addFirst = false;
    S.seed = plan; // start() fills an empty list with one box per home once the catalogue is in, then saves it (which also creates it, so the email link exists)
    start();
  }
  function resetGate() { S.step = 1; S.plan = { homes: "", taste: "" }; S.draft = { first_name: "", email: "" }; S.suggested = ""; S.seed = null; S.addFirst = false; }
  function bind(root) {
    if (root.__pdListBound) return;
    root.__pdListBound = true;
    root.addEventListener("click", onClick);
    root.addEventListener("input", onInput);
    root.addEventListener("change", onChange);
    root.addEventListener("submit", onSubmit);
  }

  // ---------- drawer button, cart-page card, sheet ----------
  // where = how the planner was opened; it becomes the Klaviyo source ("drawer" or "cart-page"; the pop-up has no button).
  function slotHTML(where) {
    return '<button type="button" class="pd-list-btn" data-pd-list-open="' + esc(where) + '"><span class="pd-list-btn__t">My Diwali list</span>' +
      '<span class="pd-list-btn__s">Plan every home\'s boxes in one place</span></button><p class="pd-list-slot__msg" role="status" hidden></p>';
  }
  function mountButton() {
    if (C.isClosed(Date.now())) return;
    var body = document.querySelector("#site-cart-sidebar .sidebar__body");
    if (!body || body.querySelector(".pd-list-slot")) return;
    var slot = document.createElement("div");
    slot.className = "pd-list-slot";
    slot.innerHTML = slotHTML("drawer");
    body.insertBefore(slot, body.firstChild); // top of the drawer, above the cart form, so it shows without scrolling whether the bag is empty or full
  }
  // The same card at the top of /cart, between the "Your bag" heading and the bag/summary grid.
  // Anchor: the grid wrapper `.cart-section` (sections/main-cart.liquid). The card is inserted as its previous sibling. Not inside <main>:
  // pd-qw.js numbers the steps with `.cart-section > main > div:first-child`, so a new first child there would take over step 1.
  // Not inside #AjaxCartForm / #AjaxCartSubtotal either: the theme (component-cart.js refreshCart, pd-qw.js) swaps the innerHTML of those on every bag change.
  // `.cart-section` itself is never replaced, so the card survives; the guard stops a second copy if this runs again.
  function mountCartCard() {
    if (C.isClosed(Date.now())) return;
    if (location.pathname.replace(/\/+$/, "").toLowerCase() !== "/cart") return;
    if (document.querySelector(".pd-list-slot--page")) return;
    var grid = document.querySelector(".cart-section");
    if (!grid || !grid.parentNode) return;
    var slot = document.createElement("div");
    slot.className = "pd-list-slot pd-list-slot--page";
    slot.innerHTML = slotHTML("cart-page");
    grid.parentNode.insertBefore(slot, grid);
  }
  function mountSlots() { mountButton(); mountCartCard(); }
  function openSheet(trigger, entry) {
    opener = trigger || null; S.entry = entry || "drawer";
    if (!sheet) {
      sheet = document.createElement("div");
      sheet.className = "pd-list-sheet";
      sheet.setAttribute("role", "dialog"); sheet.setAttribute("aria-modal", "true"); sheet.setAttribute("aria-label", "My Diwali list");
      sheet.innerHTML = '<div class="pd-list-sheet__scrim" data-act="close"></div><div class="pd-list-sheet__card">' +
        '<button type="button" class="pd-list-sheet__x" data-act="close" aria-label="Close">×</button><div class="pd-list" data-pd-list-host></div></div>';
      document.body.appendChild(sheet);
      bind(sheet);
    }
    S.host = sheet.querySelector("[data-pd-list-host]"); S.mode = "sheet";
    sheet.hidden = false; document.documentElement.classList.add("pd-list-lock");
    start();
    var first = sheet.querySelector("input, select, .pd-list__cta"); if (first) first.focus(); else focusTitle();
  }
  function closeSheet() {
    if (!sheet) return;
    settleSwap(false); // closing while the swap prompt is up answers it "no"
    var undecided = !S.me && !sheet.hidden; // closed before giving details: the pop-up stays away for a week
    sheet.hidden = true; document.documentElement.classList.remove("pd-list-lock");
    S.addFirst = false; // the box stays on this phone's list; next time the planner opens as usual
    if (undecided) { try { localStorage.setItem(LS_DISMISSED, String(Date.now())); } catch (e) {} }
    flushIfPending();
    if (pageHost) { S.host = pageHost; S.mode = "page"; start(); } // the sheet was opened on top of the list page
    if (opener && opener.focus) opener.focus();
  }

  // ---------- auto pop-up ----------
  // Counts this page view for the browser session. 0 when sessionStorage is off, which keeps the pop-up away.
  function countPageView() {
    try { var n = (parseInt(sessionStorage.getItem(SS_PV), 10) || 0) + 1; sessionStorage.setItem(SS_PV, String(n)); return n; } catch (e) { return 0; }
  }
  function typing() { var a = document.activeElement, t = a && a.tagName; return t === "INPUT" || t === "TEXTAREA" || t === "SELECT" || !!(a && a.isContentEditable); }
  // A Klaviyo pop-up that is actually showing: rendered, not display:none or hidden, and with a size. We never close Klaviyo's forms; we just stay out of the way.
  function klaviyoPopupShowing() {
    var els = document.querySelectorAll('[data-testid="POPUP"], [aria-label="POPUP Form"]');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]), r = els[i].getBoundingClientRect();
      if (cs.display !== "none" && cs.visibility !== "hidden" && r.width > 0 && r.height > 0) return true;
    }
    return false;
  }
  function autoCtx(pageViews) {
    var dismissed = 0, shown = false;
    try { dismissed = parseInt(localStorage.getItem(LS_DISMISSED), 10) || 0; } catch (e) {}
    try { shown = sessionStorage.getItem(SS_SHOWN) === "1"; } catch (e) {}
    return { now: Date.now(), pageViews: pageViews, hasDetails: !!(S.me || load(LS_ME)), dismissedAt: dismissed, shownThisSession: shown, path: location.pathname, // details read fresh: another tab may have given them
      drawerOpen: !!document.querySelector(".sidebar--opened") || document.documentElement.classList.contains("pd-switch-open") || typing() || klaviyoPopupShowing(), // a bag or menu drawer, a theme dialog, a field being typed in, or a Klaviyo pop-up
      sheetOpen: !!(sheet && !sheet.hidden) };
  }
  // Second page view onward: wait 5 s, ask again (the shopper may have opened the bag or the planner meanwhile), then open the sheet once per session.
  // In a background tab nothing opens and the once-a-session flag is not used: when the tab is next shown, the 5 s starts again.
  function armAutoOpen(pageViews) {
    if (autoArmed) return;
    autoArmed = true;
    setTimeout(function () {
      autoArmed = false;
      if (!C.shouldAutoOpen(autoCtx(pageViews))) return;
      if (document.visibilityState !== "visible") { openWhenVisible(pageViews); return; }
      try { sessionStorage.setItem(SS_SHOWN, "1"); } catch (e) {}
      openSheet(null, "pop-up");
    }, POPUP_DELAY_MS);
  }
  function openWhenVisible(pageViews) {
    function onVisible() {
      if (document.visibilityState !== "visible") return;
      document.removeEventListener("visibilitychange", onVisible);
      armAutoOpen(pageViews);
    }
    document.addEventListener("visibilitychange", onVisible);
  }
  function maybeAutoOpen(pageViews) {
    if (C.shouldAutoOpen(autoCtx(pageViews))) armAutoOpen(pageViews);
  }

  // ---------- page ----------
  function linkId() { var id = new URLSearchParams(location.search).get("l"); return id && C.isValidId(id) ? id : null; }
  function mountPage() {
    var host = document.getElementById("pd-list-page");
    if (!host) return;
    pageHost = host; S.host = host; S.mode = "page"; bind(host);
    if (C.isClosed(Date.now())) return render("closed");
    var id = linkId();
    if (id && id !== S.list.id) {
      render("loading");
      api("GET", "/api/lists/" + id).then(function (res) {
        if (!res || !C.isValidId(res.id)) throw new Error("unreadable reply");
        S.list = fromServer(res, true);
        keep(LS_LIST, S.list);
        if (!S.me) { S.me = { first_name: "", email: "" }; keep(LS_ME, S.me); }
        api("POST", "/api/lists/" + id + "/mark", { kind: "opened" }, { keepalive: true }).catch(function () {});
        start(true);
      }).catch(function (e) {
        // Only a list the server says is gone (404/410) is "not found"; a dropped connection, a timeout or a 5xx is a load error the shopper can retry.
        render(e && (e.status === 404 || e.status === 410) ? "notfound" : "error");
      });
      return;
    }
    if (id && id === S.list.id) api("POST", "/api/lists/" + id + "/mark", { kind: "opened" }, { keepalive: true }).catch(function () {});
    start();
  }

  // ---------- for the rest of the site (pd-r2.js: card and product-page buttons, the bottom bar's List tab) ----------
  // add(): with details given, the box joins the list at once (pulled from the server first, so an edit on another device is not lost)
  // and the page shows its own "Added" note; a new shopper gets the sheet, straight at name and email, with the box already on the list.
  function addBox(variantId, entry, trigger) {
    if (C.isClosed(Date.now())) return Promise.resolve({ ok: false, reason: "closed" });
    var ready = S.me && S.list.id && !S.list.pending ? pullList() : Promise.resolve();
    return ready.then(function () {
      var r = C.addBoxLine(S.list.lines, variantId);
      if (!r.added) { if (!/^\d+$/.test(String(variantId))) return { ok: false, reason: "bad-id" }; openSheet(trigger, entry); return { ok: false, opened: true, reason: "full" }; }
      S.list.lines = r.lines; S.focusLine = r.index;
      if (S.me) {
        touch(); // saves to the server and schedules the "your list is saved" email, as any edit does
        if (S.host && S.view === "list") { renderRows(); renderSummary(); focusNewLine(); }
        return { ok: true, opened: false, count: C.boxCount(S.list.lines) };
      }
      S.list.updated_at = Date.now(); S.list.pending = true; keep(LS_LIST, S.list); // kept on this phone; saved once they give their details
      S.addFirst = true;
      openSheet(trigger, entry);
      return { ok: true, opened: true, count: C.boxCount(S.list.lines) };
    });
  }
  window.PDList = {
    closed: function () { return C.isClosed(Date.now()); },
    count: function () { return C.boxCount(S.list.lines); },
    open: function (entry, trigger) { if (C.isClosed(Date.now())) return false; openSheet(trigger || null, own(SOURCES, entry) ? entry : "drawer"); return true; },
    add: function (variantId, entry, trigger) { return addBox(variantId, own(SOURCES, entry) ? entry : "drawer", trigger || null); }
  };

  function init() {
    mountSlots();
    if (location.pathname.replace(/\/$/, "") === PAGE_PATH) mountPage();
    document.addEventListener("click", function (e) { var b = e.target.closest("[data-pd-list-open]"); if (b) { e.preventDefault(); openSheet(b, b.getAttribute("data-pd-list-open")); } });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && sheet && !sheet.hidden) closeSheet(); });
    document.addEventListener("cart-updated", mountSlots, true);
    document.addEventListener("pd-mode", mountSlots, true);
    window.addEventListener("online", flushIfPending);
    document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") onLeave(); });
    window.addEventListener("pagehide", onLeave);
    maybeAutoOpen(countPageView());
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
